export const getParentPath = (path: string): string => {
  const segments = path.split('/').filter(Boolean) // Split the path into segments

  if (segments[segments.length - 1].includes(':')) {
    return `/${segments.slice(0, -2).join('/')}`// Remove one [name]/[id] pair
  }
  else {
    return `/${segments.slice(0, -1).join('/')}`
  }
}
